import { type FC } from 'react';

import { ListingContext } from '@/microfrontends/listing/shared/context/ListingAppContext';
import { type ListingAppContext } from '@/microfrontends/listing/shared/types/context';

import { useActivePinIdSelector } from '@/packages/redux-state/store/slices/mapControls';

import { ComplaintFlowContainer } from './ComplaintFlowContainer';
import { ListingByPinContainer } from './ListingByPinContainer';
import { ListingContainer } from './ListingContainer';

type ApplicationListingProps = {
  context: ListingAppContext;
};

export const ApplicationListingContainer: FC<ApplicationListingProps> = ({ context }) => {
  const activePinId = useActivePinIdSelector();

  return (
    <ListingContext context={context}>
      {activePinId ? <ListingByPinContainer /> : <ListingContainer />}
      <ComplaintFlowContainer />
    </ListingContext>
  );
};
